import { ComposePluginViewState } from 'owa-mail-compose-store';
import { createComposeFeedbackViewState } from 'owa-compose-feedback';
import { createDockingViewState } from 'owa-editor-docking-plugin';
import createEmojiPickerViewState from 'owa-editor-emoji-picker-plugin/lib/utils/createEmojiPickerViewState';
import createAtMentionsViewState from 'owa-editor-mentions-picker-plugin/lib/utils/createAtMentionsViewState';
import { createPasteOptionViewState } from 'owa-editor-paste-option-plugin';
import createRibbonViewState from 'owa-editor-ribbonplugin/lib/utils/createRibbonViewState';
import { createTableEditViewState } from 'owa-editor-table-edit-plugin';
import { createForgottenAttachmentsPluginViewState } from 'owa-editor-forgotten-attachments-plugin';
import createImageResizeViewState from 'owa-inline-image-resize-plugin/lib/utils/createImageResizeViewState';
import createInlineImageViewState from 'owa-inline-image/lib/utils/createInlineImageViewState';

export default function createComposePluginViewState(
    pendingSocialActivityTags: string[],
    isRibbonShown: boolean,
    isInlineCompose: boolean
): ComposePluginViewState {
    return {
        emojiPicker: createEmojiPickerViewState(),
        docking: createDockingViewState(isRibbonShown, isInlineCompose),
        ribbon: createRibbonViewState(),
        mentionsPicker: createAtMentionsViewState(pendingSocialActivityTags),
        pasteOption: createPasteOptionViewState(),
        tableEdit: createTableEditViewState(),
        forgottenAttachments: createForgottenAttachmentsPluginViewState(),
        smartCompose: createComposeFeedbackViewState(),
        inlineImageResize: createImageResizeViewState(),
        inlineImage: createInlineImageViewState(),
    };
}
